export const api = {
  endPoint: "https://mess-management-rnth.onrender.com", // cloud hoisted
  // endPoint: "http://localhost:5000", // local
};
